import React, { Component } from "react";

import { withAppState } from "../../../shared/containers/containerAppState";
import { withAuth } from "../../../shared/containers/containerAuth";
import CollapsibleWrapper from "./../../../shared/collapsibleWrapper";
import SecondSideBarInner from "../../../shared/secondSideBarInner";
import SideSecondBar from "../../sides/sideSecondBar";
import FormItem from "./../../../shared/items/static/formItem";
import CarsGroupsFilter from "./../cars/carsGroupsFilter";
import CarsStatusesFilter from "./../cars/carsStatusesFilter";

import variables from "./../../../values.scss";
import CarWinterCompanyFilter from "../cars/carWinterCompanyFilter";
import CarsSensorFilter from "../cars/CarsSensorFilter";

const TITLE = "Фильтры";

class CarsSecondSideBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewItems: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { isCarsSecondSideBarOpen } = this.props;

    if (prevProps.isCarsSecondSideBarOpen && !isCarsSecondSideBarOpen)
      setTimeout(
        function () {
          this.setState({ viewItems: false });
        }.bind(this),
        parseInt(variables.animateTransition) * 1000
      );
    else if (isCarsSecondSideBarOpen && !this.state.viewItems) this.setState({ viewItems: true });
  }

  render() {
    const { isCarsSecondSideBarOpen, onCloseCarsSecondSideBar, data } = this.props;

    return (
      <SideSecondBar isOpen={isCarsSecondSideBarOpen} title={TITLE} handleClick={onCloseCarsSecondSideBar}>
        {this.state.viewItems ? (
          <React.Fragment>
            <SecondSideBarInner>
              <CollapsibleWrapper title="Основные">
                {/*          <FormItem title="Тип">
                    <CarsTypesFilter />
                  </FormItem>

                  <FormItem title="Марка-модель">
                    <CarsBrandsFilter />
                  </FormItem> */}
                {data.isWinter ? (
                  <FormItem title="Компании ЕОСК">
                    <CarWinterCompanyFilter />
                  </FormItem>
                ) : null}

                <FormItem title="Группа">
                  <CarsGroupsFilter />
                </FormItem>
              </CollapsibleWrapper>
            </SecondSideBarInner>

            <SecondSideBarInner>
              <CollapsibleWrapper title="Статус">
                <CarsStatusesFilter />
              </CollapsibleWrapper>
            </SecondSideBarInner>

            <SecondSideBarInner>
              <CollapsibleWrapper title="Датчики">
                <CarsSensorFilter />
              </CollapsibleWrapper>
            </SecondSideBarInner>
          </React.Fragment>
        ) : null}
      </SideSecondBar>
    );
  }
}

export default withAuth(withAppState(React.memo(CarsSecondSideBar)));
